import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'CONTEXTUAL_DATA_SHOW_ERROR':
      return action.error;

    case 'CONTEXTUAL_DATA_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'CONTEXTUAL_DATA_SHOW_LOADING':
      return action.loading;

    case 'CONTEXTUAL_DATA_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'CONTEXTUAL_DATA_SHOW_RETRIEVED_SUCCESS':
      return action.retrieved;

    case 'CONTEXTUAL_DATA_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({
  error, loading, retrieved,
});
